const Category = {
  Dal: 'Dal',
  ChickenGravy: 'Chicken Gravy',
  Rice: 'Rice',
  MuttonGravy: 'Mutton Gravy',
  Vegetarian: 'Vegetarian',
  Side: 'Side',
  Kebab: 'Kebab',
  NonIndian: 'Non-Indian',
  FmbItem: 'Item',
  Sweets: 'Sweets'
}

export default Category;